var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.219,
    height: 38.073,
    viewBox: "0 0 41.219 38.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67400",
    "data-name": "Group 67400",
    transform: "translate(16898.609 -3437.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M18695.543-4110.526h-17.789a3.094,3.094,0,0,1-2.58-1.351,3.1,3.1,0,0,1-.359-2.895l5.447-14.521a3.147,3.147,0,0,1,2.939-2.039h27.1a3.1,3.1,0,0,1,2.219.921,3.135,3.135,0,0,1,.922,2.146v.146a3.228,3.228,0,0,1-.2,1.033l-2.7,7.2a8.963,8.963,0,0,0-2.937-2.106,8.942,8.942,0,0,0-3.662-.776,9.01,9.01,0,0,0-9,9,8.975,8.975,0,0,0,.6,3.234Zm-20.912-11.323a1.36,1.36,0,0,1-1.408-1.4v-17.945a3.146,3.146,0,0,1,3.141-3.142h7.256a3.148,3.148,0,0,1,2.227.92l3.354,3.363a3.143,3.143,0,0,0,2.227.92h13.074a2.533,2.533,0,0,1,2.531,2.527,2.685,2.685,0,0,1-2.682,2.682h-23.406a3.163,3.163,0,0,0-1.967.689,3.152,3.152,0,0,0-1.1,1.767l-1.893,8.524A1.354,1.354,0,0,1,18674.631-4121.849Z",
    transform: "translate(-35571.332 7582.55)",
    fill: "#1eb1ff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61854",
    "data-name": "Group 61854",
    transform: "translate(-17674.391 2967.786)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40008",
    "data-name": "Ellipse 40008",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(800 494)",
    fill: "#1eb1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82389",
    "data-name": "Path 82389",
    d: "M-21506.316,4033.635l1.77,1.771,3.475-3.473",
    transform: "translate(22310.695 -3532.911)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedProjects);
export default __webpack_public_path__ + "static/media/completed-projects.526be757eb5371d44771f8e5c15cdc7d.svg";
export { ForwardRef as ReactComponent };